import dayjs from 'dayjs'

/*
 * Le numéro de la supervision, s'il est configuré pour ce déploiement. Aucun aujourd'hui : le bouton
 * « Appeler la supervision » reste grisé tant qu'il n'y en a pas.
 */
export const SUPERVISION_PHONE = process.env.VUE_APP_SUPERVISION_PHONE || null

/* Les raisons d'un problème sur place (FieldIssueReason côté serveur). */
export const FIELD_ISSUE_REASONS = ['person-absent', 'site-not-compliant', 'wrong-equipment', 'other']

/** Ce que la liste et la fiche du portail lisent de la même façon dans une pose. */
export default {
  methods: {
    /** Qui appeler sur place : le contact du site s'il est donné, sinon la personne. */
    contactOf(order) {
      const site = order?.siteContact || {}
      const person = order?.person || {}
      if (site.phone) {
        return { name: site.name || null, phone: site.phone }
      }
      if (person.phone) {
        return { name: this.personName(order), phone: person.phone }
      }
      return site.name ? { name: site.name, phone: null } : null
    },

    /** « aujourd'hui », « à venir », « en retard » ou « sans date ». */
    dayOf(order) {
      if (!order.scheduledAt) return 'undated'
      const day = dayjs(order.scheduledAt)
      if (day.isSame(dayjs(), 'day')) return 'today'
      return day.isBefore(dayjs(), 'day') ? 'late' : 'upcoming'
    },

    /** L'heure seule pour aujourd'hui, le jour et l'heure sinon. */
    whenOf(order) {
      if (!order.scheduledAt) return null
      return dayjs(order.scheduledAt).isSame(dayjs(), 'day')
        ? this.$options.filters.formatDate(order.scheduledAt, 'HH[h]mm')
        : this.$options.filters.formatDate(order.scheduledAt, 'ddd DD/MM [·] HH[h]mm')
    },

    /** Ce qui manque encore avant de poser, hors la pose elle-même. */
    waitingFor(order) {
      return (order?.installationBlockers || []).map(this.requirementLabel).join(', ')
    },

    /** Une phrase entière par prérequis, pour un technicien qui ne connaît pas le parcours ; sinon, son nom. */
    fieldRequirementText(section, requirement) {
      const key = `onboarding.field.${section}.${requirement}`
      return this.$te(key) ? this.$t(key) : this.requirementLabel(requirement)
    },

    issueReasonLabel(reason) {
      return this.$t(`onboarding.field.issue.reason.${reason}`)
    },
  },
}
